/**
 * Refer to assessments-tab.component.ts for the detailed layout of the
 * Nursing Assessment form.
 */

import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Timestamp } from 'firebase/firestore';
import {
  Assessment,
} from 'src/app/calvin-emr-shared/models/assessment.model';
import {
  ProviderNotifiedFormGroup, ProviderNotifiedAssessmentHelpers
} from 'src/app/calvin-emr-shared/models/assessments/provider-notified.model';
import {
  PsychosocialFormGroup, PsychosocialAssessmentHelpers
} from 'src/app/calvin-emr-shared/models/assessments/psychosocial.model';
import {
  IntakeOutputFormGroup, IntakeOutputAssessmentHelpers
} from 'src/app/calvin-emr-shared/models/assessments/intake-output.model';
import {
  PainAssessmentHelpers, PainFormGroup
} from 'src/app/calvin-emr-shared/models/assessments/pain.model';
import {
  IntegumentaryAssessmentHelpers, IntegumentaryFormGroup
} from 'src/app/calvin-emr-shared/models/assessments/integumentary.model';
import {
  GenitourinaryAssessmentHelpers, GenitourinaryFormGroup
} from 'src/app/calvin-emr-shared/models/assessments/genitourinary.model';
import {
  GastrointestinalAssessmentHelpers, GastrointestinalFormGroup
} from 'src/app/calvin-emr-shared/models/assessments/gastrointestinal.model';
import {
  MusculoskeletalAssessmentHelpers, MusculoskeletalFormGroup
} from 'src/app/calvin-emr-shared/models/assessments/musculoskeletal.model';
import {
  NeurologicalAssessmentHelpers, NeurologicalFormGroup
} from 'src/app/calvin-emr-shared/models/assessments/neurological.model';
import {
  RespiratoryAssessmentHelpers, RespiratoryFormGroup
} from 'src/app/calvin-emr-shared/models/assessments/respiratory.model';
import {
  CardiovascularAssessmentHelpers, CardiovascularFormGroup
} from 'src/app/calvin-emr-shared/models/assessments/cardiovascular.model';
import {
  HEENTAssessmentHelpers, HEENTFormGroup
} from 'src/app/calvin-emr-shared/models/assessments/HEENT.model';
import {
  GeneralAppearanceAssessmentHelpers, GeneralAppearanceFormGroup
} from 'src/app/calvin-emr-shared/models/assessments/general-appearance.model';

export function formToAssessment(fg: UntypedFormGroup): Assessment {
  return new Assessment(
    getFormDate(fg.controls.date as UntypedFormControl),
    GeneralAppearanceAssessmentHelpers.formToObject(fg.controls.generalAppearance as GeneralAppearanceFormGroup),
    HEENTAssessmentHelpers.formToObject(fg.controls.heent as HEENTFormGroup),
    CardiovascularAssessmentHelpers.formToObject(fg.controls.cardiovascular as CardiovascularFormGroup),
    RespiratoryAssessmentHelpers.formToObject(fg.controls.respiratory as RespiratoryFormGroup),
    NeurologicalAssessmentHelpers.formToObject(fg.controls.neurological as NeurologicalFormGroup),
    MusculoskeletalAssessmentHelpers.formToObject(fg.controls.musculoskeletal as MusculoskeletalFormGroup),
    GastrointestinalAssessmentHelpers.formToObject(fg.controls.gastrointestinal as GastrointestinalFormGroup),
    GenitourinaryAssessmentHelpers.formToObject(fg.controls.genitourinary as GenitourinaryFormGroup),
    PsychosocialAssessmentHelpers.formToObject(fg.controls.psychosocial as PsychosocialFormGroup),
    IntegumentaryAssessmentHelpers.formToObject(fg.controls.integumentary as IntegumentaryFormGroup),
    PainAssessmentHelpers.formToObject(fg.controls.painAssessment as PainFormGroup),
    IntakeOutputAssessmentHelpers.formToObject(fg.controls.intakeOutput as IntakeOutputFormGroup),
    ProviderNotifiedAssessmentHelpers.formToObject(fg.controls.providerNotified as ProviderNotifiedFormGroup)
  );
}

function getFormDate(fc: UntypedFormControl) {
  // Assume fc.value is of the form YYYY-MM-DDTHH:MM; this allows us to convert it
  //  to a date
  const val = fc.value;
  if (val) {
    return Timestamp.fromDate(new Date(val));
  } else {
    return Timestamp.now();
  }
}
